import React from 'react';
import PropTypes from 'prop-types';

import { trackEvent } from '../../../../../helpers/analytics';
import { useCreateNoteMutation } from '../../../../../services/contacts';
import { NoteForm } from '../noteForm';

export const NewNote = ({ queryParams, contactId }) => {
  const [createNote, { isLoading }] = useCreateNoteMutation();

  const onSave = async (values, { resetForm }) => {
    trackEvent('contacts:notes:add', {
      origin: 'full_profile',
    });
    await createNote({ queryParams, contactId, values });
    resetForm();
  };

  return <NoteForm onSuccess={onSave} isLoading={isLoading} />;
};

NewNote.propTypes = {
  queryParams: PropTypes.object,
  contactId: PropTypes.number.isRequired,
};

NewNote.defaultProps = {
  queryParams: {},
};
